import React, { useState } from 'react';

const FAQAccordion = ({ question, answer, id, isOpen, toggleAccordion  }) => {
    // const [isOpen, setIsOpen] = useState(false);
    // const toggleAccordion = () => setIsOpen(!isOpen);

    return (
        <div className={`accordion-item ${isOpen ? 'bordervs' : ''}`}>
            <h2 className="accordion-header" id={`heading${id}`}>
                <button
                    className={`accordion-button  ${isOpen ? '' : 'collapsed'}`}
                    type="button"
                    onClick={() => toggleAccordion(id)}
                    aria-expanded={isOpen ? 'true' : 'false'}
                    aria-controls={`collapse${id}`}
                >
                    {question}
                </button>
            </h2>
            <div
                id={`collapse${id}`}
                className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                aria-labelledby={`heading${id}`}
                data-bs-parent="#accordionExample" >
                <div className="accordion-body">
                    <p>{answer}</p>
                </div>
            </div>
        </div>
    );
};

const FAQSection = () => {
    const [openAccordionId, setOpenAccordionId] = useState(null);

    const toggleAccordion = (id) => {
        setOpenAccordionId(prevId => (prevId === id ? null : id));
    };
    const faqData = [
        {
            id: 1,
            question: 'What is Hey Visuals?',
            answer:
                'Hey Visuals is an AI-powered tool designed for social media content creators. It helps users generate high-quality captions, images, and avatars, enabling consistent posting and reducing design costs.',
        },
        {
            id: 2,
            question: 'What features does Hey Visuals offer?',
            answer: (
                <>
                    Hey Visuals offers three primary features:
                    <br />
                    <b>1. Caption Generation:</b> Create engaging and creative captions tailored to your content.
                    <br />
                    <b>2. Image Generation:</b> Generate visually stunning images for your posts.
                    <br />
                    <b>3. Avatar Maker:</b> Design custom avatars for branding or personal use.
                </>
            ),
        },
        {
            id: 3,
            question: 'How does the Basic Plan differ from the Professional Plan?',
            answer:
                'The Basic Plan provides up to 50 captions, 20 images, and 5 avatars per month, along with access to a standard library and priority email support. The Professional Plan offers unlimited access to captions, images, and avatars, a premium library, team collaboration (up to 3 members), and analytics insights.',
        },
        {
            id: 4,
            question: 'Can I upgrade or downgrade my subscription plan?',
            answer:
                'Yes, you can upgrade or downgrade your subscription plan anytime through your account settings. Changes will take effect at the start of the next billing cycle.',
        },
        {
            id: 5,
            question: 'Are there any additional costs or add-ons?',
            answer: 'There is no hidden extra cost.',
        },
        {
            id: 6,
            question: 'What payment methods do you accept?',
            answer: 'We accept major credit cards and debit cards. All payments are processed securely.',
        },
        {
            id: 7,
            question: 'Is there a refund policy?',
            answer:
                'We offer a 30-day money-back guarantee for the Basic and Professional Plans. If you\'re unsatisfied, contact our support team for a refund.',
        },
        {
            id: 8,
            question: 'How can I contact customer support?',
            answer: (
                <>
                    You can reach our support team via:
                    <br />
                    <b>
                        Email: <a href="mailto:support@heyvisuals.com">support@heyvisuals.com</a>
                    </b>
                    <br />
                    <b>Live Chat:</b> Available for Basic and Professional Plan users.
                    <br />
                    Community forums and help center for Free Plan users.
                </>
            ),
        },
        {
            id: 9,
            question: 'Can I cancel my subscription at any time?',
            answer:
                'Yes, you can cancel your subscription anytime through your account settings. Your access will remain active until the end of the current billing period.',
        },
        {
            id: 10,
            question: 'Are the AI-generated images copyright-free?',
            answer:
                'Yes, all AI-generated images created using Hey Visuals are copyright-free and can be used for personal or commercial purposes.',
        },
        {
            id: 11,
            question: 'Is Hey Visuals suitable for businesses?',
            answer:
                'Absolutely! Hey Visuals is ideal for influencers, small businesses, and marketing teams looking to streamline content creation and reduce costs.',
        },
        {
            id: 12,
            question: 'Do I need design skills to use Hey Visuals?',
            answer:
                'No design skills are required! Hey Visuals is user-friendly and designed to make content creation easy for everyone.',
        },
    ];
    const half = Math.ceil(faqData.length / 2);
    const firstColumn = faqData.slice(0, half);
    const secondColumn = faqData.slice(half);
    return (
        <section className="faqvs-main">
            <div className="faqvs-outer pt-0">
                <div className="container small">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="faqvs-inner">
                                <h2 className="common-vstitle">
                                    <span className="title-vsdeco">Frequently Asked Questions</span>
                                </h2>
                                <h2 className="common-vstitle">Everything You Need to Know Before You Join</h2>
                                <div className="aqccordion-wrapper pt-4">
                                    <div className="accordion" id="accordionExample">
                                    <div className="row">
                                            <div className="col-md-6 mt-8">
                                                {firstColumn.map((faq) => (
                                                    <FAQAccordion key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} isOpen={openAccordionId === faq.id}  toggleAccordion={toggleAccordion} />
                                                ))}
                                            </div>
                                            <div className="col-md-6 mt-8">
                                                {secondColumn.map((faq) => (
                                                    <FAQAccordion key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} isOpen={openAccordionId === faq.id}  toggleAccordion={toggleAccordion} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FAQSection;
